export const MEDICATION_TIMINGS = ["BREAKFAST", "LUNCH", "DINNER", "BEDTIME"] as const;

export type MedicationTiming = (typeof MEDICATION_TIMINGS)[number];

export const MEDICATION_TIMING_LABELS: Record<MedicationTiming, string> = {
  BREAKFAST: "Breakfast",
  LUNCH: "Lunch",
  DINNER: "Dinner",
  BEDTIME: "Bedtime",
};

export const formatMedicationTimings = (timing: MedicationTiming[]): string =>
  MEDICATION_TIMINGS.filter((it) => timing.includes(it))
    .map((it) => MEDICATION_TIMING_LABELS[it])
    .join(", ");

export const formatMedicationTimingLines = (timing: MedicationTiming[]): string[] => {
  const labels = MEDICATION_TIMINGS.filter((it) => timing.includes(it)).map(
    (it) => MEDICATION_TIMING_LABELS[it]
  );
  const lines: string[] = [];
  for (let i = 0; i < labels.length; i += 2) {
    lines.push(labels.slice(i, i + 2).join(", "));
  }
  return lines;
};

export type MedicationApiDto = {
  name: string;
  timing: MedicationTiming[];
};

export type Medication = {
  name: string;
  timing: MedicationTiming[];
};

export const toMedication = (dto: MedicationApiDto): Medication => ({ ...dto });

export const toMedicationApiDto = (medication: Medication): MedicationApiDto => ({
  name: medication.name,
  timing: medication.timing,
});

export type MedicationTakenAnswer = "YES" | "NO";

export type MedicationLogApiDto = {
  medicationTaken: MedicationTakenAnswer;
  note?: string | null;
};

export type MedicationLog = MedicationLogApiDto;
